exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='reset-home'] .mat-card {\n  display: -ms-flexbox;\n  display: flex;\n  height: 370px;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  min-width: 500px;\n  width: 500px;\n}\n[data-component='reset-home'] .mat-card #box {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -ms-flex-align: center;\n      align-items: center;\n}\n[data-component='reset-home'] .mat-card #box .btn {\n  margin: 14px;\n  width: 200px;\n}\n[data-component='reset-home'] .mat-card #box #info {\n  text-align: center;\n}\n[data-component='reset-home'] .mat-card #box .notice {\n  color: #989898;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n[data-component='reset-home'] .mat-card #box .material-icons {\n  color: #989898;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-pass/reset/reset-home/reset-home.component.styl
// module id = ../../../../../src/app/master/change-pass/reset/reset-home/reset-home.component.styl
// module chunks = main